import { useForm, type SubmitHandler } from "react-hook-form"

import useFormLocalStorage from "@/hooks/use-form-local-storage"
import { APP_VERSION } from "@/constants/general"
import Form from "@/components/forms/reusables/form"
import useFormStates from "@/hooks/use-form-states"
import RHFTextarea from "@/components/form-fields/rhf-textarea"
import type {
    CreateCommunicationFormInput,
} from "@/types"
import { useCreateContainerRequest } from "@/hooks/api/use-communication"

const CreateContainerRequestForm = ({
    collectionCompanyId,
    closeCallback,
    toggleSuccess,
} : {
    collectionCompanyId: string | number,
    closeCallback?: () => void,
    toggleSuccess: () => void,
}) => {

    const formDataId = `createContainerRequestForm-${collectionCompanyId}-v${APP_VERSION}`

    const initialValues = {
        description: '',
    }
    
    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
    } = useForm({
        defaultValues: { ...initialValues },
    })

    const [isLoadedFromLocalStorage, handleFormReset] = useFormLocalStorage({
        control,
        formDataId,
        reset,
        initialValues
    })

    const {
        resetWithVersion,
        requestInProgress,
        setRequestInProgress,
    } = useFormStates(handleFormReset)

    const mutation = useCreateContainerRequest(
        collectionCompanyId,
        {
            setRequestInProgress,
            formDataId,
            onSuccessCallback: toggleSuccess,
        }
    )

    const onSubmit: SubmitHandler<CreateCommunicationFormInput> = data => {
        setRequestInProgress(true)
        mutation.mutate(data)
    }

    return (
        <Form
            onSubmit={handleSubmit(onSubmit)}
            heading={'Objednání velkého kontejneru'}
            closeCallback={closeCallback}
            isLoadedFromLocalStorage={isLoadedFromLocalStorage}
            isDirty={isDirty}
            resetWithVersion={resetWithVersion}
            requestInProgress={requestInProgress}
            buttonText={'Objednat'}
        >
            <RHFTextarea
                name="description"
                control={control}
                label="Popis"
                size="small"
                required
            />
        </Form>
    )
}

export default CreateContainerRequestForm
